import React from 'react';
import { defaultLocale } from './strings';

export const LocaleContext = React.createContext(defaultLocale);


const LocaleProvider = ({ children }) => (
  <LocaleContext.Provider value={defaultLocale}>
    {children}
  </LocaleContext.Provider>
);

export default LocaleProvider;
